'use client';

import Link from 'next/link';
import Image from 'next/image';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-400 pt-[72px] pb-10">
      <div className="max-w-7xl mx-auto px-10">
        <div className="grid grid-cols-1 md:grid-cols-[2fr_1fr_1fr_1fr] gap-12 mb-14">
          {/* Brand */}
          <div>
            <Image src="/logo.png" alt="" width={48} height={48} className="mb-4" />
            <div className="text-white font-bold text-base mb-1.5">India Case Status</div>
            <p className="text-sm leading-[1.6] max-w-[320px] m-0">
              Litigation tracking for Indian courts. Built for practising advocates, small firms,
              in-house teams, and litigants.
            </p>
            <p className="mt-3 text-xs leading-relaxed text-gray-500">
              Questlore Indian Gamer Media LLP
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-white text-xs tracking-[0.08em] uppercase font-semibold mb-4">Product</h4>
            <div className="flex flex-col gap-2.5">
              <Link href="/#how" className="text-sm text-gray-400 hover:text-white transition-colors">How it works</Link>
              <Link href="/#features" className="text-sm text-gray-400 hover:text-white transition-colors">Features</Link>
              <Link href="/#coverage" className="text-sm text-gray-400 hover:text-white transition-colors">Coverage</Link>
              <Link href="/#pricing" className="text-sm text-gray-400 hover:text-white transition-colors">Pricing</Link>
            </div>
          </div>

          {/* Track by Court — curated; full directory lives at /courts */}
          <div>
            <h4 className="text-white text-xs tracking-[0.08em] uppercase font-semibold mb-4">Track by Court</h4>
            <div className="flex flex-col gap-2.5">
              <Link href="/supreme-court-case-status" className="text-sm text-gray-400 hover:text-white transition-colors">Supreme Court</Link>
              <Link href="/delhi-high-court-case-alerts" className="text-sm text-gray-400 hover:text-white transition-colors">Delhi High Court</Link>
              <Link href="/bombay-high-court-case-tracking" className="text-sm text-gray-400 hover:text-white transition-colors">Bombay High Court</Link>
              <Link href="/karnataka-high-court-case-tracking" className="text-sm text-gray-400 hover:text-white transition-colors">Karnataka High Court</Link>
              <Link href="/nclt-tracker" className="text-sm text-gray-400 hover:text-white transition-colors">NCLT</Link>
              <Link href="/courts#tribunals" className="text-sm text-gray-400 hover:text-white transition-colors">Consumer Courts</Link>
              <Link href="/courts" className="text-sm text-accent-500 font-semibold hover:text-[#e0c06a] transition-colors">
                All courts &amp; cities <span aria-hidden="true">&rarr;</span>
              </Link>
            </div>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white text-xs tracking-[0.08em] uppercase font-semibold mb-4">Company</h4>
            <div className="flex flex-col gap-2.5">
              <Link href="/#guides" className="text-sm text-gray-400 hover:text-white transition-colors">Guides</Link>
              <Link href="/blog" className="text-sm text-gray-400 hover:text-white transition-colors">Blog</Link>
              <Link href="/contact" className="text-sm text-gray-400 hover:text-white transition-colors">Contact</Link>
              <Link href="/privacy" className="text-sm text-gray-400 hover:text-white transition-colors">Privacy</Link>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-800 pt-7 flex flex-wrap items-center justify-between gap-4 text-[13px]">
          <div>
            <p className="m-0">&copy; {currentYear} India Case Status. All rights reserved.</p>
            <p className="m-0 mt-1 text-gray-500">
              India Case Status is owned and operated by Questlore Indian Gamer Media LLP, an independent
              service not affiliated with eCourts or the Government of India.
            </p>
          </div>
          <div className="flex gap-[18px]">
            <Link href="/terms" className="text-gray-400 hover:text-white transition-colors">Terms</Link>
            <Link href="/privacy" className="text-gray-400 hover:text-white transition-colors">Privacy</Link>
            {/* No status page exists yet (checked — no /status route, no external status URL
                anywhere in the codebase). Shown as plain text so the footer matches the design
                without linking to a 404; wire this up to a real page when one exists. */}
            <span className="text-gray-400">Status</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
